import { H3, Image, PortableText, TypeWrapper } from '@ahmdigital/ui';
import classNames from 'classnames';

import constants from '../../../../ahm-constants';
import styles from './styles.module.sass';
import TileCta from './cta';

// Note: this component has been moved to ahm-ui, ahm-sales cleanup impending (FW-1251)
type FeaturesTileProps = {
  image: {
    alt: string;
    src: string;
  };
  summary?: string | unknown[];
  title: string | unknown[];
  urlObject?: {
    name?: string;
    url?: string;
  };
  withSimpleBit?: boolean;
};

const FeaturesTile = ({ image, summary, title, urlObject, withSimpleBit = true }: FeaturesTileProps) => {
  const isLifeStageSection = Boolean(urlObject?.url?.startsWith(`${constants.URLS.SALES.REFINE_PRICE}?scale=`));

  return (
    <div className={isLifeStageSection ? styles.lifeStageTileWrapper : styles.wrapper}>
      <TypeWrapper variant="center">
        <div className={classNames({ [styles.lifeStageContentWrapper!]: isLifeStageSection })}>
          {image && <Image {...image} className={styles.image} />}
          <H3 looksLike={withSimpleBit ? 'h4' : 'h6'} variant={withSimpleBit ? 'simpleBit' : undefined}>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string | unknown[]' is not assignable to type 'PortableTextSource | undefined'. */}
            <PortableText source={title} />
          </H3>
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string | unknown[] | undefined' is not assignable to type 'PortableTextSource | undefined'. */}
          <PortableText source={summary} />
        </div>
        <TileCta urlObject={urlObject} isLifeStageSection={isLifeStageSection} />
      </TypeWrapper>
    </div>
  );
};

export default FeaturesTile;
